import { IUploaderColumnConfig } from "../../../../../../components/ui/UploaderFlow/types/types";
import { CommonColDefFieldNamesEnum } from "../../../enums/AgGridColDefFieldNameEnum";

export const BUSINESS_AREA_GRID_UPLOADER_CONFIG: IUploaderColumnConfig[] = [{
  key: CommonColDefFieldNamesEnum.Name,
  name: 'Name',
  type: 'text',
  placeholder: 'Business Area Name',
  required: true
}
]